class DefaultColors {

    /* const waggonColors = [
        'rgb(0, 149, 255)',
        'rgb(255, 0, 149)',
        'rgb(255, 251, 0)',
        'rgb(59, 59, 59)',
        'rgb(255, 102, 0)',
        'rgb(5, 203, 0)',
        'rgb(94, 20, 174)',
        'rgb(222, 0, 0)',
        'rgb(11, 0, 222)'
    ]; */

    
    static colors = {
        cyan: {
            name: 'CYAN',
            rgb: 'rgb(0, 130, 255)'
        },
        magenta: {
            name: 'MAGENTA',
            rgb: 'rgb(255, 0, 130)'
        },
        yellow: {
            name: 'YELLOW',
            rgb: 'rgb(255, 240, 0)'
        },
        black: {
            name: 'BLACK',
            rgb: 'rgb(50, 50, 50)'
        },
        orange: {
            name: 'ORANGE',
            rgb: 'rgb(255, 100, 15)'
        },
        green: {
            name: 'GREEN',
            rgb: 'rgb(50, 180, 50)'
        },
        viollet: {
            name: 'VIOLLET',
            rgb: 'rgb(120, 70, 180)'
        },
        red: {
            name: 'RED',
            rgb: 'rgb(255, 25, 25)'
        },
        blue: {
            name: 'BLUE',
            rgb: 'rgb(0, 50, 190)'
        },
        white: {
            name: 'WHITE',
            rgb: 'rgb(255, 255, 0)'
        },
        open: {
            name: 'OPEN',
            rgb: 'rgb(0, 0, 0)'
        }
    };

    static nextColor(id) {
        // Retrieve the color values as an array
        const colorValues = Object.values(DefaultColors.colors);
        
        // Calculate the next index with wrap-around
        const nextId = (id + 1) % colorValues.length;

        // Return the corresponding color object
        return colorValues[nextId];
    }

    static getId(id) {
        // Retrieve the color values as an array
        const colorValues = Object.values(DefaultColors.colors);
        
        // Return the corresponding color object
        return colorValues[id];
    }

    static getRGB(ids) {
        // Retrieve the color values as an array
        const colorValues = Object.values(DefaultColors.colors);

        // Return all rgb values of the given ids
        const rgbValues = ids.map(id => colorValues[id].rgb);

        return rgbValues;

    }

    static randomRGB() {
        const r = Math.floor(Math.random() * 256);
        const g = Math.floor(Math.random() * 256);
        const b = Math.floor(Math.random() * 256);
        return `rgb(${r}, ${g}, ${b})`;
    }
}

class DefaultLink {

    static ID = 'LINK-LINK-LINK-LINK';

    static RandomID = (len = 5) => {
        // 'LINK-LINK-LINK-LINK' generate a random string with capital letters and numbers like this pattern
        //const pattern = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
        const pattern = 'LINK0123';
        let result = '';
        for (let i = 0; i < len; i++) {
            const randomIndex = Math.floor(Math.random() * pattern.length);
            result += pattern.charAt(randomIndex);
        }
        return `${result}-${result}-${result}-${result}`;
    }

    static INFO = {
        filesize: 0,
        channels: 0,
        duration: 0
    };

    static RandomINFO = () => {
        return {
            filesize: Math.floor(Math.random() * 1000000),
            duration: Math.random() * 100 / 50
        };
    }

    static INFOSPYIMAGE = {
        filesize: 0,
        combination: 0,
        dimension: 0,
        duration: 0
    };

    static INFOSPYLINK = {
        filesize: 0,
        transform: 0,
        duration: 0
    }
}

class DefaultMessage {

    static MESSAGE = {
        'calculating': 'Calculating...',
        'downloading': 'Downloading...'
    };
}

class DefaultColormodes {

    /*  
    CMYK + 1 (5C),
    CMYK + 2 (6C),
    CMYK + 3 (7C),
    CMYK + 4 (8C)
    */

    static colormodes = [
        {
            key: 'gray', 
            value: {
                name: 'GRAY', 
                uiName: 'GREY (1C)',
                channel: 1
            }
        },
        { 
            key: 'rgb', 
            value: { 
                name: 'RGB', 
                uiName: 'RGB',
                channel: 3
            } 
        },
        {
            key: 'cmyk', 
            value: { 
                name: 'CMYK', 
                uiName: 'CMYK (4C)',
                channel: 4
            } 
        },
        { 
            key: 'lab', 
            value: { 
                name: 'LAB', 
                uiName: 'LAB',
                channel: 3
            } 
        }
    ];

    static getObjByKey(key) {
        return DefaultColormodes.colormodes.find(obj => obj.key === key);
    }
}

export { 
    DefaultColors,
    DefaultColormodes,
    DefaultLink,
    DefaultMessage
}
